import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && !String(cfg.url).includes("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Ocurrió un error. Intente de nuevo.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => `${(x.loc || []).slice(-1)[0] || ""}: ${x.msg}`).join(" · ");
  return String(d);
}

export const money = (v, c = "USD") =>
  new Intl.NumberFormat(c === "CRC" ? "es-CR" : "en-US", { style: "currency", currency: c }).format(Number(v) || 0);

export const fdate = (s) => (s ? new Date(s).toLocaleDateString("es-CR", { year: "numeric", month: "short", day: "numeric" }) : "—");

export const MODE_LABEL = {
  one_time: "Compra única", monthly: "Suscripción mensual", annual: "Suscripción anual", enterprise: "Licencia empresarial",
  quote: "Cotización personalizada", demo: "Solicitud de demostración", trial: "Prueba gratuita",
};
export const PURCHASABLE = ["one_time", "monthly", "annual", "enterprise", "trial"];
export const AVAIL = {
  available: { label: "Disponible", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  demo_only: { label: "Bajo demostración", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  in_development: { label: "En desarrollo", cls: "bg-amber-50 text-amber-700 border-amber-200" },
};
